module.exports = __webpack_public_path__ + "static/media/event-1.eb163199.jpg";